import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Accpermit from "@/pages/erroraccount.vue";

// user center pages
import ServiceList from "@/pages/ServiceList.vue";
import ContentSolution from "@/pages/HelpDesk/ContentSolution.vue";
import Formrequest from "@/pages/HelpDesk/ServiceFormRequest.vue";
import voteJob from "@/pages/HelpDesk/ServiceVote.vue";
import Directory from "@/pages/Directory/SearchDirectory.vue"
import Covid from "@/pages/CovidCheck/CovidCheckPoint.vue"
import CovidQr from "@/pages/CovidCheck/CovidCheckPointQr.vue"
import CovidHistoryCheckIn from "@/pages/CovidCheck/CovidHistoryCheckIn.vue"
import TimeAttandance from "@/pages/TimeAttandance/TimeCheck.vue"
import smartAuthen from "@/pages/TimeAttandance/smartauthen.vue"
import onlineDocument from "@/pages/Document/mainDocument.vue"
import Reserved from "@/pages/Reserved/mainreserved.vue";
import TicketReserved from "@/pages/Reserved/ticketreserved.vue";
import LeaveOfAbsent from "@/pages/LeaveOfAbsence/dasboardLeave.vue";
import formAbsent from "@/pages/LeaveOfAbsence/formabsent.vue";
import CalendarView from "@/pages/Calendar/calendarView.vue";
import MyProfile from "@/pages/UserProfile/mainProfile.vue";
import JobFair from "@/pages/JobFair/mainjobfair.vue";
import studentactivity from "@/pages/StudentActivity/listactivity.vue";
import CompanyDetail from "@/pages/JobFair/viewjobfair.vue";
import Vehicle from "@/pages/Reserved/car_reserve.vue";
import ListBill from "@/pages/Payment/listBill.vue";

// user staff pages
import addCard from "@/pages/BackOffice/addCard.vue";
import stdmail from "@/pages/BackOffice/sendMail.vue";
import selfscreening from "@/pages/BackOffice/selfsceen.vue";
import surveymuic from "@/pages/BackOffice/surveyMUIC.vue";
import checkgraduate from "@/pages/BackOffice/checkgraduate.vue"

// user Lecture pages
import ListTeaching from "@/pages/TeachingRecords/HistoryRecords.vue";
import FormRecordTeaching from "@/pages/TeachingRecords/FormRecord.vue";
import EditTeaching from "@/pages/TeachingRecords/EditTeaching.vue";
// import TeachingWage from "@/pages/TeachingRecords/mainteaching.vue";

// portal-page
import Portal from "@/pages/Portal/portal.vue";
// import newPortal from "@/pages/Portal/portal_new.vue";

// Other
import Election from "@/pages/Election/VoteElection.vue";
import formscreen from "@/pages/screencovid/formscreen.vue";
import formatkgraduate from "@/pages/screencovid/formatkgraduate.vue";
import Skyplus from "@/pages/skyplus/page.vue";
// import OpenhouseSurvey from "@/pages/Openhouse/Survey.vue";
// import OpenhouseRegis from "@/pages/Openhouse/Register.vue";
// import MuActivate from "@/pages/MuActivate.vue";
// import NotPermission from "@/pages/NotPermission.vue";
// import ClassSchule from "@/pages/ClassSchule/ClassSchule.vue";
// import SmoVote from "@/pages/SmoVote/MainContent.vue";

/* MY MUIC */
const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/portal",
    meta: {
      layout: 'default',
      requiresAuth: true
    },
    children: [
      /* Ticket */
      {
        path: "/icservice",
        name: "IC Service",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: ServiceList
      },
      {
        path: "/formrequest",
        name: "Create new query",
        props:true,
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: Formrequest
      },
      {
        path: "/contentsolution/:id",
        name: "Contentsolution",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: ContentSolution,
        props: true,
      },
      /* Reserved */
      {
        path: "/icbooking",
        name: "IC Booking",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: Reserved
      },
      {
        path: "/ticketreserved",
        name: "Ticket Reserved",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: TicketReserved
      },
      /* Teaching wage */
      // {
      //   path: "/teachingwage",
      //   name: "Teaching wage",
      //   meta: {
      //     layout: 'default',
      //     permitC: ['faculty']
      //   },
      //   component: TeachingWage
      // },
      /* Teaching Records */
      {
        path: "/teaching",
        name: "Teaching record",
        meta: {
          layout: 'default',
          permitC: ['faculty']
        },
        component: ListTeaching
      },
      {
        path: "/formteaching",
        name: "Teaching record submission form",
        meta: {
          layout: 'default',
          permitC: ['faculty']
        },
        component: FormRecordTeaching
      },
      {
        path: "/editteaching/:id",
        name: "Teaching record submission form edit",
        meta: {
          layout: 'default',
          permitC: ['faculty']
        },
        component: EditTeaching,
        props: true,
      },
      /* vinchle */
      {
        path: "/icvehicle",
        name: "Vehicle",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty']
        },
        component: Vehicle
      },
      /* Directory */
      {
        path: "/directory",
        name: "Directory",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: Directory
      },
      /* Covid */
      {
        path: "/checkinhistory",
        name: "Time record",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: CovidHistoryCheckIn
      },
      /* Document */
      {
        path: "/document",
        name: "Document",
        meta: {
          layout: 'default',
          permitC: ['staff']
        },
        component: onlineDocument
      },
      /* Leave of Absence */
      {
        path: "/leaveofabsent",
        name: "Leave of Absence",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty']
        },
        component: LeaveOfAbsent
      },
      // {
      //   path: "/writeformleave",
      //   name: "Write a leave",
      //   meta: {
      //     layout: 'default',
      //     permitC: ['staff','faculty']
      //   },
      //   component: formAbsent
      // },
      /* Calendar view */
      {
        path: "/calendar",
        name: "Calendar",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty']
        },
        component: CalendarView
      },
      /* Profile */
      {
        path: "/profile",
        name: "Profile",
        meta: {
          layout: 'default',
          permitC: ['staff','faculty','student']
        },
        component: MyProfile
      },
      /* MUIC JOB FAIR */
      {
        path: "/jobfair",
        name: "Job Application",
        meta: {
          layout: 'default',
          permitC: ['student']
        },
        component: JobFair,
        props: true,
      },
      {
        path: "/companydetail/:id",
        name: "Company Detail",
        meta: {
          layout: 'default',
          permitC: ['student']
        },
        component: CompanyDetail,
        props: true,
      },
      /* payment bills */
      {
        path: "/tuitionpayment",
        name: "Tuition Payment",
        meta: {
          layout: 'default',
          permitC: ['staff','student']
        },
        component: ListBill
      },
      /* covid screen */
      // {
      //   path: "/atk",
      //   name: "MUIC Pass",
      //   meta: {
      //     layout: 'default',
      //     permitC: ['staff','faculty','student']
      //   },
      //   component: formscreen
      // },
      /* covid screen */
      /* student-activity */
      {
        path: "/studentactivity",
        name: "Student Activity",
        meta: {
          layout: 'default',
          permitC: ['student']
        },
        component: studentactivity
      },
      /* ClassSchule */
      // {
      //   path: "/class_schule",
      //   name: "Class schedule",
      //   meta: {
      //     layout: 'default',
      //     permitC: ['staff','faculty','student']
      //   },
      //   component: ClassSchule
      // },
      /* Account activate */
      // {
      //   path: "/muaccount",
      //   name: "MU Account",
      //   meta: {
      //     layout: 'default',
      //   },
      //   component: MuActivate
      // },
      // {
      //   path: "/notpermit",
      //   name: "Not permit",
      //   meta: {
      //     layout: 'default',
      //   },
      //   component: NotPermission
      // },
    ]
  },
  // vote mail ticket
  {
    path: "/voteJob",
    name: "mailTicketVote",
    meta: {
      layout: 'default',
    },
    component: voteJob
  },
  /* back office */
  {
    path: "/survey_muic",
    name: "muicsurvey",
    meta: {
      layout: 'default',
      // requiresAuth: true,
      // allowedRoles
    },
    component: surveymuic
  },
  {
    path: "/addcard",
    name: "add Office",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // allowedRoles
    },
    component: addCard
  },
  {
    path: "/stdmail",
    name: "send mail student",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // allowedRoles
    },
    component: stdmail
  },
  {
    path: "/selfscreening",
    name: "self screening",
    meta: {
      layout: 'default',
      // requiresAuth: true,
      // allowedRoles
    },
    component: selfscreening
  },
  {
    path: "/checkgraduate",
    name: "checkgraduate",
    meta: {
      layout: 'default',
      // requiresAuth: true,
      // allowedRoles
    },
    component: checkgraduate
  },
  {
    path: "/ic-covidscreening",
    name: "formatkgraduate",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // allowedRoles
    },
    component: formatkgraduate
  },
  /* Time Attandance */
  {
    path: "/timeattandance",
    name: "Attandance",
    meta: {
      layout: 'default',
    },
    component: TimeAttandance
  },
  {
    path: "/smart_authen",
    name: "Smart Authen",
    meta: {
      layout: 'default',
    },
    component: smartAuthen
  },
  /* KIOSK - Covid */
  {
    path: "/checkpoint",
    name: "Covid",
    meta: {
      layout: 'default',
      // requiresAuth: true,
      // permitC: ['staff','faculty']
    },
    component: Covid
  },
  {
    path: "/qrcheckpoint",
    name: "Covid",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // permitC: ['staff','faculty']
    },
    component: CovidQr
  },
  /* Portal */
  {
    path: "/portal",
    name: "Portal",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // permitC: ['staff','faculty']
    },
    component: Portal
  },
  // {
  //   path: "/newportal",
  //   name: "newPortal",
  //   meta: {
  //     layout: 'default',
  //     requiresAuth: true,
  //   },
  //   component: newPortal
  // },
  {
    path: "/accountpermit",
    name: "Accpermit",
    meta: {
      layout: 'default',
      requiresAuth: true,
      permitC: []
    },
    component: Accpermit,
    props: true,
  },
  /* 404 */
  {
    path: "*",
    name: "NotFound",
    meta: {
      layout: 'default',
      // requiresAuth: true
    },
    component: NotFound,
    props: true,
  },
  /* Election */
  {
    path: "/electionvote",
    name: "Election",
    meta: {
      layout: 'default',
      requiresAuth: true,
      // permitC: ['staff','faculty']
    },
    component: Election
  },
  /* Election */
  /* openhouse 2020 */
  // {
  //   path: "/openhouse/survey",
  //   name: "OpenhouseSurvey",
  //   meta: {
  //     layout: 'default',
  //     // requiresAuth: true,
  //     // permitC: ['staff','faculty']
  //   },
  //   component: OpenhouseSurvey
  // },
  // {
  //   path: "/openhouse/register",
  //   name: "OpenhouseRegis",
  //   meta: {
  //     layout: 'default',
  //     // requiresAuth: true,
  //     // permitC: ['staff','faculty']
  //   },
  //   component: OpenhouseRegis
  // },
  /* openhouse 2020 */
  /* smo-Election */
  // {
  //   path: "/smovote",
  //   name: "SmoVote",
  //   meta: {
  //     layout: 'default',
  //     requiresAuth: true,
  //     // permitC: ['student']
  //   },
  //   component: SmoVote
  // },
  // {
  //   path: "/infoparty",
  //   name: "InfoSmoVote",
  //   meta: {
  //     layout: 'default',
  //     requiresAuth: true,
  //     // permitC: ['student']
  //   },
  //   component: SmoVote,
  // },
  // {
  //   path: "/voteparty",
  //   name: "SmoVoteParty",
  //   meta: {
  //     layout: 'default',
  //     requiresAuth: true,
  //     // permitC: ['student']
  //   },
  //   component: SmoVote,
  // },
  // {
  //   path: "/finishvote",
  //   name: "VoteSuccess",
  //   meta: {
  //     layout: 'default',
  //     requiresAuth: true,
  //     // permitC: ['student']
  //   },
  //   component: SmoVote,
  // },
  /* smo-Election */
  /* skyplus */
  {
    path: "/faq",
    name: "skyplus",
    meta: {
      layout: 'default',
    },
    component: Skyplus,
  },
  /* skyplus */
];
/* MY MUIC */

/**
   * Asynchronously load view (Webpack Lazy loading compatible)
   * The specified component must be inside the Views folder
   * @param  {string} name  the filename (basename) of the view to load.
    function view(name) {
      var res= require('../components/Dashboard/Views/' + name + '.vue');
      return res;
    };
**/

export default routes;